import 'ion-rangeslider';
import {mockups} from "../mockups";

export function initCatalogPageLanding() {
    if ($('#catalog_page_landing').length === 0) return;

    const AJAX_MODE = 'test';
    const AJAX_URL = AJAX_MODE === 'dev' ? '' : 'https://ks-store.internetlab.ru';

    const $desktopRangeSlider = $("#range_slider");
    const $mobileRangeSlider = $("#range_slider_mobile");
    const $minPriceDesktopInput = $('#min_price_desktop_input');
    const $maxPriceDesktopInput = $('#max_price_desktop_input');
    const $minPriceMobileInput = $('#min_price_mobile_input');
    const $maxPriceMobileInput = $('#max_price_mobile_input');
    const $desktopSizesWrapper = $('[data-desktop-filter-sizes]');
    const $mobSizesWrapper = $('[data-mobile-filter-sizes]');
    const $categoriesBlock = $('.categories');
    const $desktopFilterBlock = $('.filter.desktop');
    const $mobFilterBlock = $('.filter.mobile');
    const $mobFilterWrapper = $mobFilterBlock.find('.filter-wrapper');
    const $categoriesWrapper = $('[data-categories-wrapper]');
    const $products = $('[data-products-wrapper]');

    let $desktopRangeSliderInstance = null;
    let $mobileRangeSliderInstance = null;
    let defaultCategories = [];
    let defaultSizes = ['all'];
    let chosenCategories = [];
    let isLast = false;
    let isLoading = false;

    let FILTER_SETTINGS = {
        minPrice: 0,
        maxPrice: 0,
        sizes: [],
        categories: [],
        mainSubId: ''
    };

    let SORT_PARAMS = {
        limit: 12,
        offset: 0,
    }

    setFilterSettings()
    initRangeSlider();
    initHandlers();

    function setFilterSettings() {
        FILTER_SETTINGS = {...JSON.parse(JSON.stringify($('[data-filter-settings]').data('filter-settings')))}

        let sizesHTML = '';
        let categoriesHTML = '';

        //размеры
        FILTER_SETTINGS.sizes.forEach(size => {
            const disabledClass = size.isAvailable ? '' : 'disabled';
            const chosenClass = size?.isChosen ? 'checked': '';

            sizesHTML += `
                <label class="custom-checkbox-label ${chosenClass} ${disabledClass}" data-size="${size.id}">${size.name}
                    <input type="checkbox" class="custom-checkbox" value="${size.name}">
                </label>`;
        });

        //если цены равны
        if (FILTER_SETTINGS.maxPrice === FILTER_SETTINGS.minPrice){
            $('.price-block').addClass('loading');
        }

        //если 1 размер
        if (FILTER_SETTINGS.sizes.length === 1){
            $('.sizes-block').addClass('loading');
        }

        $desktopSizesWrapper.html(sizesHTML);
        $mobSizesWrapper.html(sizesHTML);

        //категории
        FILTER_SETTINGS.categories.forEach(category => {
            const chosenClass = category?.isChosen ? 'chosen': '';

            if(category?.isChosen){
                chosenCategories.push(category.id);

            }


            if(category?.icon){
                categoriesHTML += `
                    <div class="switcher category ${chosenClass}" data-category="${category.id}">
                        <div class="category-icon" style="-webkit-mask-image: url(${category.icon});mask-image: url(${category.icon});"></div>
                        ${category.name}
                    </div>`;

            }else{
                categoriesHTML += `<div class="switcher category ${chosenClass}" data-category="${category.id}">${category.name}</div>`;
            }

        });

        defaultCategories = [`${FILTER_SETTINGS.mainSubId}`];

        if(!chosenCategories.length){
            chosenCategories = [...defaultCategories];
        }

        $categoriesWrapper.html(categoriesHTML);

        //если высота категорий меньше 65 - скрываем Ещё
        if($categoriesWrapper[0]?.scrollHeight < 65){
            $('.show-more-categories').hide();
        }
    }

    function initRangeSlider() {
        let currentMinValue = FILTER_SETTINGS.minPrice;
        let currentMaxValue = FILTER_SETTINGS.maxPrice;

        if(FILTER_SETTINGS?.current_min && FILTER_SETTINGS?.current_min !== '0'){
            currentMinValue = FILTER_SETTINGS.current_min;
        }

        if(FILTER_SETTINGS?.current_max && FILTER_SETTINGS?.current_max !== '0'){
            currentMaxValue = FILTER_SETTINGS.current_max;
        }

        $desktopRangeSlider.ionRangeSlider({
            skin: 'round',
            type: "double",
            min: FILTER_SETTINGS.minPrice,
            max: FILTER_SETTINGS.maxPrice,
            from: currentMinValue,
            to: currentMaxValue,
            grid: false,
            hide_min_max: true,
            hide_from_to: true,
            onChange: (data) => {
                $minPriceDesktopInput.add($minPriceMobileInput).val(data.from);
                $maxPriceDesktopInput.add($maxPriceMobileInput).val(data.to);
                $mobileRangeSliderInstance.update(data);
            },
            onFinish: (data) => {
                SORT_PARAMS.offset = 0;
                getProducts('filter');
            }
        });

        $mobileRangeSlider.ionRangeSlider({
            skin: 'round',
            type: "double",
            min: FILTER_SETTINGS.minPrice,
            max: FILTER_SETTINGS.maxPrice,
            from: currentMinValue,
            to: currentMaxValue,
            grid: false,
            hide_min_max: true,
            hide_from_to: true,
            onChange: (data) => {
                $minPriceMobileInput.add($minPriceDesktopInput).val(data.from);
                $maxPriceMobileInput.add($maxPriceDesktopInput).val(data.to);
                $desktopRangeSliderInstance.update(data);
            },
            onFinish: (data) => {
                SORT_PARAMS.offset = 0;
                getProducts('filter');
            }
        });

        $desktopRangeSliderInstance = $desktopRangeSlider.data("ionRangeSlider");
        $mobileRangeSliderInstance = $mobileRangeSlider.data("ionRangeSlider");

        $minPriceDesktopInput.val(currentMinValue);
        $maxPriceDesktopInput.val(currentMaxValue);
        $minPriceMobileInput.val(currentMinValue);
        $maxPriceMobileInput.val(currentMaxValue);

        $minPriceDesktopInput.add($minPriceMobileInput).on('change', function () {
            let currentInputVal = +$(this).val();
            //связываем моб и десктопный инпуты
            $minPriceDesktopInput.add($minPriceMobileInput).val(currentInputVal);

            //если введённое значение меньше минимального
            if (currentInputVal < FILTER_SETTINGS.minPrice) {
                $minPriceDesktopInput.add($minPriceMobileInput).val($minPriceDesktopInput.val());

                $desktopRangeSliderInstance.update({
                    from: FILTER_SETTINGS.minPrice
                });

                $mobileRangeSliderInstance.update({
                    from: FILTER_SETTINGS.minPrice
                });

                SORT_PARAMS.offset = 0;
                getProducts('filter');
                return;
            }

            //если введённое значение больше максимального или больше выбранного макс значения
            if (currentInputVal > FILTER_SETTINGS.maxPrice || currentInputVal > $maxPriceDesktopInput.val()) {
                $minPriceDesktopInput.add($minPriceMobileInput).val($maxPriceDesktopInput.val());

                $desktopRangeSliderInstance.update({
                    from: FILTER_SETTINGS.maxPrice
                });

                $mobileRangeSliderInstance.update({
                    from: FILTER_SETTINGS.maxPrice
                });

                SORT_PARAMS.offset = 0;
                getProducts('filter');
                return;
            }

            $desktopRangeSliderInstance.update({
                from: +$(this).val()
            })

            $mobileRangeSliderInstance.update({
                from: +$(this).val()
            })

            SORT_PARAMS.offset = 0;
            getProducts('filter');
        });

        $maxPriceDesktopInput.add($maxPriceMobileInput).on('change', function () {
            let currentInputVal = +$(this).val();
            //связываем моб и десктопный инпуты
            $maxPriceDesktopInput.add($maxPriceMobileInput).val(currentInputVal);

            //если введённое значение меньше минимального
            if (currentInputVal > FILTER_SETTINGS.maxPrice) {
                $maxPriceDesktopInput.add($maxPriceMobileInput).val($maxPriceDesktopInput.val());

                $desktopRangeSliderInstance.update({
                    to: FILTER_SETTINGS.maxPrice
                });

                $mobileRangeSliderInstance.update({
                    to: FILTER_SETTINGS.maxPrice
                });

                SORT_PARAMS.offset = 0;
                getProducts('filter');
                return;
            }

            //если введённое значение меньше минимального или меньше выбранного минимума
            if (currentInputVal < FILTER_SETTINGS.minPrice || currentInputVal < $minPriceDesktopInput.val()) {
                $maxPriceDesktopInput.add($maxPriceMobileInput).val($minPriceDesktopInput.val());

                $desktopRangeSliderInstance.update({
                    to: +$minPriceDesktopInput.val()
                });
                $mobileRangeSliderInstance.update({
                    to: +$minPriceMobileInput.val()
                });

                SORT_PARAMS.offset = 0;
                getProducts('filter');
                return;
            }

            $desktopRangeSliderInstance.update({
                to: +$(this).val()
            });

            $mobileRangeSliderInstance.update({
                to: +$(this).val()
            });

            SORT_PARAMS.offset = 0;
            getProducts('filter');
        });

        //при ините слайдеров смотрим на доступность блока "Сбросить фильтры"
        checkResetFiltersStyle();
    }

    function initHandlers() {
        //развернуть/свернуть все размеры десктоп
        $('[data-show-all-catalog-sizes]').on('click', () => {
            $('[data-desktop-filter-sizes]').toggleClass('opened');
        });

        //развернуть/свернуть все категории
        $('.show-more-categories').on('click', function () {
            $(this).toggleClass('clicked');
            $('.categories-wrapper').toggleClass('opened');
        });

        //показать моб фильтр
        $mobFilterBlock.on('click', function (e) {
            const $currentTarget = $(e.target);

            if ($currentTarget.hasClass('filter')) {
                $(this).toggleClass('opened');
            }
        });

        //сброс фильтров
        $('[data-reset-filters]').on('click', () => {
            //reset не работает, если вводим сумму из инпута (почему-то), поэтому update
            $desktopRangeSliderInstance.update({
                to: FILTER_SETTINGS.maxPrice,
                from: FILTER_SETTINGS.minPrice,
            });

            $mobileRangeSliderInstance.update({
                to: FILTER_SETTINGS.maxPrice,
                from: FILTER_SETTINGS.minPrice,
            });

            $minPriceDesktopInput.val(FILTER_SETTINGS.minPrice);
            $maxPriceDesktopInput.val(FILTER_SETTINGS.maxPrice);
            $minPriceMobileInput.val(FILTER_SETTINGS.minPrice);
            $maxPriceMobileInput.val(FILTER_SETTINGS.maxPrice);

            $desktopSizesWrapper.add($mobSizesWrapper).find('.custom-checkbox-label.checked').each(function () {
                const $customCheckboxBlock = $(this);
                const $customCheckBox = $customCheckboxBlock.find('input');

                $customCheckBox.prop('checked', false);
                $customCheckboxBlock.removeClass('checked');
            });

            chosenCategories.length = 0;
            chosenCategories = [...defaultCategories];
            $('.categories-wrapper').find('[data-category].chosen').each(function () {
                $(this).removeClass('chosen');
            });
            SORT_PARAMS.offset = 0;
            getProducts('filter');
            $('[data-reset-filters]').css('display', 'none');
        });

        //категории
        $('[data-category]').on('click', e => {
            const $clickedCategory = $(e.currentTarget);

            $clickedCategory.toggleClass('chosen');

            const $chosenCategoriesCollection = $('.categories-wrapper').find('[data-category].chosen');

            if ($chosenCategoriesCollection.length === 0) {
                chosenCategories = [...defaultCategories];

            } else {
                chosenCategories.length = 0;

                $chosenCategoriesCollection.each(function () {
                    const categoryValue = $(this).data('category');
                    chosenCategories.push(`${categoryValue}`);
                });
            }

            SORT_PARAMS.offset = 0;
            getProducts('filter');
        });

        //размеры
        $('.custom-checkbox-label').on('click', e => {
            e.preventDefault();
            const $clickedLabel = $(e.currentTarget);
            const sizeId = $clickedLabel.data('size');
            const $input = $clickedLabel.find('input');

            if ($input.prop('checked')) {
                $input.prop('checked', false);
                $clickedLabel.removeClass('checked');
                $desktopSizesWrapper.add($mobSizesWrapper).find(`[data-size='${sizeId}']`).removeClass('checked');
                $desktopSizesWrapper.add($mobSizesWrapper).find(`[data-size='${sizeId}'] input`).prop('checked', false);

            } else {
                $input.prop('checked', true);
                $clickedLabel.addClass('checked');
                $desktopSizesWrapper.add($mobSizesWrapper).find(`[data-size='${sizeId}']`).addClass('checked');
                $desktopSizesWrapper.add($mobSizesWrapper).find(`[data-size='${sizeId}'] input`).prop('checked', true);
            }

            SORT_PARAMS.offset = 0;
            getProducts('filter');
        });

        //свернуть/раскрыть моб фильтр по цене
        $('[data-roll-mob-filter-price-trigger]').on('click', function () {
            $(this).toggleClass('rolled');
        });

        //свернуть/раскрыть моб фильтр по размерам
        $('[data-roll-mob-filter-sizes-trigger]').on('click', function () {
            $(this).toggleClass('rolled');
        });

        //запрос при скролле
        $(window).on('scroll', () => {
            if ($(window).scrollTop() + $(window).height() >= $('#list_end').offset().top - $(window).height() - 200) {
                if (!isLast && !isLoading) {
                    SORT_PARAMS.offset = SORT_PARAMS.offset + SORT_PARAMS.limit;
                    getProducts('scroll')
                }
            }
        });
    }

    function getProducts(type) {
        setUrlParameters();
        checkResetFiltersStyle();

        isLoading = true;
        showPreloader();

        const data = {
            filter: getCurrentFilterValues()
        };

        $.ajax({
            url: `/ajax/getProducts/`,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data),
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                if (data) {
                    successFn(data, type);

                } else {
                    errorFn();
                }
            },
            error: function (data) {
                if (AJAX_MODE === 'dev') {
                    if (type === 'filter') {
                        data = mockups.filteredProducts;

                    } else if (type === 'scroll') {
                        data = mockups.scrollProducts;
                    }

                    if (data) {
                        successFn(data, type);

                    } else {
                        errorFn();
                    }

                } else {
                    errorFn();
                }
            },
            timeout: 30000
        });

        function successFn(data, type) {
            isLoading = false;
            hidePreloader();
            if (!data.length) {
                isLast = true;

            } else {
                isLast = false;
            }
            if (type === 'scroll') {
                $products.append(renderProductsHTML(data));
            }
            if (type === 'filter') {
                if(!data.length){
                    const noFilteredProductsFoundHTML = `
                       <div class=" col w-100 display-flex flex-direction-column p-l-mob-15">
                            <h3 class="h3 no-margin-bottom">По вашему запросу ничего не найдено</h3>
                            <p class="body-16 margin-top-8">Попробуйте поменять фильтры или выбрать другую категорию</p>
                       </div>
                    `;
                    $products.html('').append(noFilteredProductsFoundHTML);
                    return;
                }
                $products.html('').append(renderProductsHTML(data));
            }
        }

        function errorFn(){
            hidePreloader();
        }

        function showPreloader(){
            $categoriesBlock.add($desktopFilterBlock).add($mobFilterWrapper).addClass('loading');
            $('#list_end').addClass('loading');
        }

        function hidePreloader(){
            $('#list_end').removeClass('loading');
            $categoriesBlock.add($desktopFilterBlock).add($mobFilterWrapper).removeClass('loading');
        }
    }

    function renderProductsHTML(products) {
        let result = '';

        products.forEach(product => {
            const price = product.price;
            const name = product.name;
            const img = product.img;
            const link = product.link;
            const isDiscount = product.isDiscount;
            const discountPrice = product.discountPrice;
            let discountClass = '';

            let priceHTML = `<span class="caption-24 font-bold margin-bottom-6">${price}  ₽</span>`;

            if(isDiscount){
                priceHTML = `<div class="display-flex">
                                <span class="old-price">${price} ₽</span>
                                <span class="caption-24 font-bold margin-bottom-6">${discountPrice}  ₽</span>
                             </div>`;

                discountClass = 'sale';
            }

            result += `
                <a href="${link}" class="product-card catalog ${discountClass}">
                    <img class="margin-bottom-20 border-radius-4" src="${img}" alt="${name}"/>
                    <div class="display-flex flex-direction-column">
                        ${priceHTML}
                        <span class="text-16 color-gray margin-bottom-20">${name}</span>
                    </div>
                </a>`;

        });

        return result;
    }

    function checkResetFiltersStyle(){
        if(isFilterInDefaultPosition()){
            $('[data-reset-filters]').css('display', 'none');

        }else{
            $('[data-reset-filters]').css('display', 'flex');
        }
    }

    function isFilterInDefaultPosition(){
        const currentFilterValues = getCurrentFilterValues();

        if(currentFilterValues.min !== FILTER_SETTINGS.minPrice){
            console.log(currentFilterValues.min, FILTER_SETTINGS.minPrice)
            return false;
        }

        if(currentFilterValues.max !== FILTER_SETTINGS.maxPrice){
            return false;
        }

        if(JSON.stringify(currentFilterValues.categories) !== JSON.stringify(defaultCategories)){
            return false;
        }

        if(currentFilterValues.sizes[0] !== 'all'){
            return false;
        }

        return true;
    }

    function getCurrentFilterValues() {
        const currentMin = $minPriceDesktopInput.val();
        const currentMax = $maxPriceDesktopInput.val();
        let chosenSizes = [];

        chosenSizes.length = 0;
        $desktopSizesWrapper.find(`.custom-checkbox-label.checked`).each(function () {
            chosenSizes.push(`${$(this).data('size')}`);
        });

        if (chosenSizes.length === 0) {
            chosenSizes = [...defaultSizes];
        }

        return {
            min: +currentMin,
            max: +currentMax,
            categories: chosenCategories,
            sizes: chosenSizes,
            limit: SORT_PARAMS.limit,
            offset: SORT_PARAMS.offset
        }
    }

    function setUrlParameters(){
        if(isFilterInDefaultPosition()){
            window.history.pushState(null, null, encodeURI(window.location.origin + window.location.pathname));
            return;
        }

        const filterValues = getCurrentFilterValues();
        const getParameters = encodeURI(
                '?' + 'current_min=' + `${filterValues.min}`
                + '&current_max=' + `${filterValues.max}`
                + '&current_sizes=' + `${filterValues.sizes}`
                + '&current_categories=' + `${filterValues.categories}`);

        window.history.pushState(null, null,getParameters);
    }
}